/* ============================================================
   fs-footer.js — the live status column in the footer.
   Three lines, top-left: local time, place, conditions.

   Reference (usalproject.com) asks the browser for geolocation and
   sits on "SEARCHING....." until the visitor answers — and forever
   if they decline. We get the same answer from the browser's own
   timezone with no permission prompt and no stuck state. Same
   granularity as the reference: a city, not a street.

   Weather: Open-Meteo. Data is CC BY 4.0, so the attribution link
   this file writes into the legal bar is REQUIRED — do not remove it.
   ============================================================ */
(function () {
  var WMO = {
    0:'clear sky', 1:'mainly clear', 2:'partly cloudy', 3:'overcast',
    45:'fog', 48:'freezing fog',
    51:'light drizzle', 53:'drizzle', 55:'heavy drizzle',
    56:'freezing drizzle', 57:'freezing drizzle',
    61:'light rain', 63:'rain', 65:'heavy rain',
    66:'freezing rain', 67:'freezing rain',
    71:'light snow', 73:'snow', 75:'heavy snow', 77:'snow grains',
    80:'light showers', 81:'showers', 82:'heavy showers',
    85:'snow showers', 86:'snow showers',
    95:'thunderstorms', 96:'thunderstorms', 99:'thunderstorms'
  };

  function tzCity() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      var last = tz.split('/').pop() || '';
      return last.replace(/_/g, ' ');
    } catch (e) { return ''; }
  }

  function clockText() {
    var d = new Date(), h = d.getHours(), m = d.getMinutes(), s = d.getSeconds();
    var ap = h >= 12 ? 'PM' : 'AM';
    h = h % 12; if (h === 0) h = 12;
    var p = function (n) { return n < 10 ? '0' + n : '' + n; };
    return p(h) + ':' + p(m) + ':' + p(s) + ap;
  }

  function mount() {
    var row = document.querySelector('.section-footer__row--blocks');
    if (!row || document.querySelector('.fs-foot-status')) return;
    var col = row.querySelector('.section-footer__row__col');
    if (!col) return;

    var box = document.createElement('div');
    box.className = 'fs-foot-status';
    box.innerHTML =
      '<div class="fs-foot-status__line" data-fs-clock></div>' +
      '<div class="fs-foot-status__line" data-fs-place>searching.....</div>' +
      '<div class="fs-foot-status__line" data-fs-wx></div>';
    col.insertBefore(box, col.firstChild);

    var clockEl = box.querySelector('[data-fs-clock]');
    var placeEl = box.querySelector('[data-fs-place]');
    var wxEl    = box.querySelector('[data-fs-wx]');

    clockEl.textContent = clockText();
    setInterval(function () { clockEl.textContent = clockText(); }, 1000);

    var city = tzCity();
    if (city) placeEl.textContent = city;

    loadWeather(city, wxEl);
  }

  function loadWeather(city, el) {
    if (!city) return;
    var KEY = 'fs-wx:' + city;
    try {
      var hit = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      /* 20 minutes is plenty — the reading barely moves and this keeps
         us off the API on every page view. */
      if (hit && Date.now() - hit.t < 1200000) { el.textContent = hit.v; return; }
    } catch (e) {}

    var geo = 'https://geocoding-api.open-meteo.com/v1/search?count=1&language=en&format=json&name='
            + encodeURIComponent(city);

    fetch(geo).then(function (r) { return r.json(); }).then(function (g) {
      var hitG = g && g.results && g.results[0];
      if (!hitG) throw 0;
      return fetch('https://api.open-meteo.com/v1/forecast?latitude=' + hitG.latitude
                 + '&longitude=' + hitG.longitude
                 + '&current=temperature_2m,weather_code');
    }).then(function (r) { return r.json(); }).then(function (w) {
      var c = w && w.current;
      if (!c) throw 0;
      var txt = Math.round(c.temperature_2m) + 'º and ' + (WMO[c.weather_code] || 'clear sky');
      el.textContent = txt;
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), v: txt })); } catch (e) {}
    }).catch(function () {
      /* Quietly drop the line rather than leaving a dead placeholder —
         two lines read fine, a stuck "loading" does not. */
      el.remove();
    });
  }

  function attribution() {
    var bar = document.querySelector('.section-footer__row-lower .copyright');
    if (!bar || bar.querySelector('.fs-foot-attr')) return;
    var a = document.createElement('a');
    a.className = 'fs-foot-attr';
    a.href = 'https://open-meteo.com/';
    a.rel = 'noopener';
    a.target = '_blank';
    a.textContent = 'Weather by Open-Meteo';
    bar.appendChild(a);
  }

  function init() { mount(); attribution(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
